import { Component, input, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconRegistry, MatIcon } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SnackbarConfig } from '../../types/snackbar';

@Component({
  selector: 'app-snackbar',
  standalone: true,
  imports: [CommonModule, MatIcon],
  templateUrl: './snackbar.html',
})
export class SnackbarComponent {
  config = input<SnackbarConfig>({
    type: 'info',
    message: '',
    icon: 'info-icon.svg',
  });

  width = input<string>('');
  height = input<string>('');

  constructor(
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
  ) {
    this.iconRegistry.addSvgIcon(
      'success-icon',
      this.sanitizer.bypassSecurityTrustResourceUrl('icons/check_icon.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'error-icon',
      this.sanitizer.bypassSecurityTrustResourceUrl('icons/error_icon.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'info-icon',
      this.sanitizer.bypassSecurityTrustResourceUrl('icons/info_icon.svg'),
    );
  }

  getBackgroundColor(): string {
    switch (this.config().type) {
      case 'success':
        return '#008218';
      case 'error':
        return '#F00444';
      case 'info':
        return '#0D6FFF';
      default:
        return '#0D6FFF';
    }
  }

  getIcon(): string {
    switch (this.config().type) {
      case 'success':
        return 'success-icon';
      case 'error':
        return 'error-icon';
      case 'info':
        return 'info-icon';
      default:
        return 'info-icon';
    }
  }
}
